import { createAsyncThunk,createSlice } from '@reduxjs/toolkit'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import { parseCollectionSnapshot } from '../../utils/firebaseUtils'

const name = `teams`
let unsubscribe

export const subscribeToTeams = createAsyncThunk(`${name}/subscribe`,async(_,{ getState,dispatch }) => {
  if(unsubscribe) unsubscribe()
  unsubscribe = firebase.firestore().collection(name).onSnapshot(snapshot => {
    dispatch(setTeams(parseCollectionSnapshot(snapshot)))
  })
},{ condition: () => !!firebase.auth().currentUser })

const slice = createSlice({
  name,
  initialState: {
    status: `idle`,
    data: [],
    error: null,
  },
  reducers: {
    setTeams(state,action){
      state.data = action.payload
    },
  },
})

export default slice.reducer
export const { setTeams } = slice.actions
export const selectTeams = state => state[name].data

